// components/use-case-details/use-case-workflow/agent-type-config.tsx
// Import specific icons AND the LucideIcon type
import { Activity, AlertTriangle, Bot, Brain, Code, Database,Search, Sparkles, TrendingUp } from 'lucide-react';
import React from 'react';

// Common agent types with their visual indicators
export type AgentType = 'scraping' | 'analysis' | 'generation' | 'detection' | 'optimization' | 'monitoring' | 'classification' | 'extraction' | 'conversation' | 'reasoning' | string; // Added reasoning, allow string

export interface AgentTypeConfig {
    color: string;
    // icon: LucideIcon;
    icon: React.ComponentType<any>; // Use React.ComponentType or React.ElementType
    // *** CHANGE: Store the component TYPE ***
    description: string;
    label: string; // Added label for consistency
}

export const agentTypeConfig: Record<AgentType, AgentTypeConfig> = {
    // Data Collection Agents
    "scraping": {
        color: "green",
        icon: Database, // *** FIX: Store TYPE ***
        description: "Collects data from external sources",
        label: "Scraping Agent"
    },

    // Analysis Agents
    "analysis": {
        color: "blue",
        icon: Brain,    // *** FIX: Store TYPE ***
        description: "Analyzes and processes information",
        label: "Analysis Agent"
    },

    // Generation Agents
    "generation": {
        color: "purple",
        icon: Sparkles, // *** FIX: Store TYPE ***
        description: "Creates new content or designs",
        label: "Generation Agent"
    },

    // Error Detection Agents
    "detection": {
        color: "orange",
        icon: AlertTriangle, // *** FIX: Store TYPE ***
        description: "Identifies issues and anomalies",
        label: "Detection Agent"
    },

    // Optimization Agents
    "optimization": {
        color: "cyan",
        icon: TrendingUp, // *** FIX: Store TYPE ***
        description: "Improves and refines solutions",
        label: "Optimization Agent"
    },

    // Monitoring Agents
    "monitoring": {
        color: "red",
        icon: Activity, // *** FIX: Store TYPE ***
        description: "Tracks changes over time",
        label: "Monitoring Agent"
    },

    // Classification Agents
    "classification": {
        color: "yellow",
        icon: Code, // *** FIX: Store TYPE ***
        description: "Categorizes and organizes information",
        label: "Classification Agent"
    },

     // Reasoning Agents (from previous context)
    "reasoning": {
        color: "purple", // Same as analysis for example
        icon: Brain,    // *** FIX: Store TYPE ***
        description: "Performs reasoning and logic tasks",
        label: "Reasoning Agent"
    },

    // Data Extraction Agents
    "extraction": {
        color: "indigo",
        icon: Search, // *** FIX: Store TYPE ***
        description: "Extracts specific information from data",
        label: "Extraction Agent"
    },

    // Conversation Agents
    "conversation": {
        color: "pink",
        icon: Bot,   // *** FIX: Store TYPE ***
        description: "Engages in natural language conversations",
        label: "Conversation Agent"
    }
};

// Helper functions (ensure they return full Tailwind classes)
export const getAgentBorderColor = (type: AgentType): string => {
    const color = agentTypeConfig[type]?.color || 'gray';
    // Ensure this class exists in your Tailwind config or is generated
    return `border-${color}-500`;
};

export const getAgentBgClass = (type: AgentType): string => {
    const color = agentTypeConfig[type]?.color || 'gray';
    // Ensure this class exists
    return `bg-${color}-600/30`;
};

export const getAgentTextColor = (type: AgentType): string => {
    const color = agentTypeConfig[type]?.color || 'gray';
    // Ensure this class exists
    return `text-${color}-400`;
};

// // component